import { z } from "zod";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
  }),
  response: z.object({
    openBanking: z.object({
      count: z.object({ connected: z.number(), pending: z.number() }),
      balance: z.number(),
    }),
    proAccount: z.object({
      count: z.object({ connected: z.number(), pending: z.number() }),
      balance: z.number(),
    }),
    pendingTransferRequests: z.array(
      z.object({
        id: z.string(),
        accountId: z.string(),
        accountName: z.string(),
        amount: z.string(),
        beneficiaryName: z.string(),
        createdAt: z.string(),
        currency: z.string(),
      }),
    ),
  }),
};
